// extracted by css-extract-rspack-plugin
export default {"wrapper":"CallToActionItem-module__wrapper__rLbSu4P","feedbackLink":"CallToActionItem-module__feedbackLink__NI1uv6x"};